// ── 마케터 1:1 배정 상태 판정 공용 유틸 ──────────────────────────────────────
// 2026-09-02: AssignmentBoard/AssignmentBoardCard 에 복붙돼 있던 동일 함수를 통합.
//   range(기준월 구간)는 호출부에서 항상 전달되므로 과거의 today 폴백 분기(죽은 코드)는 제거.
//   기준월은 이제 "오늘이 속한 달"(AdminMarketerConsultantPage) — 배지 의미: 이번달 재직.
import { toDateString } from '../../../utils/date';

export function fmtDate(value) {
  return value ? toDateString(value) : '';
}

/** 기준월 문자열(YYYY-MM) → { label, start, endExclusive } 구간 */
export function monthRange(basisMonth, today) {
  const fallback = String(today || '').slice(0, 7);
  const monthText = String(basisMonth || fallback);
  const [year, month] = monthText.split('-').map(Number);
  if (!Number.isInteger(year) || !Number.isInteger(month) || month < 1 || month > 12) {
    return monthRange(fallback, today);
  }
  const endYear = month === 12 ? year + 1 : year;
  const endMonth = month === 12 ? 1 : month + 1;
  return {
    label: `${year}년 ${month}월`,
    start: `${year}-${String(month).padStart(2, '0')}-01`,
    endExclusive: `${endYear}-${String(endMonth).padStart(2, '0')}-01`,
  };
}

/** 배정 행 → 기준월 구간 대비 상태. 종료(구간 전에 끝남) / 예정(구간 후 시작) / 이번달 */
export function getStatus(row, range) {
  const start = fmtDate(row.start_date);
  const end = row.end_date ? fmtDate(row.end_date) : null;
  if (end && end < range.start) return { key: 'ended', label: '종료' };
  if (start && start >= range.endExclusive) return { key: 'upcoming', label: '예정' };
  return { key: 'active', label: '이번달' };
}
